import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=9f5dfbce&scoped=true&"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=9f5dfbce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5dfbce",
  null
  
)

export default component.exports